import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import FormField from '../layout/FormField';
import FormSelect from '../layout/FormSelect';
import { useState } from 'react';
import { errorToast, sendRequest, successToast } from '../../helpers/utils';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
const BASE_URL = process.env.REACT_APP_BASE_URL;

const SignupForm = () => {
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const navigate = useNavigate();

    const validate = Yup.object({
        first_name: Yup.string().min(3, 'Too Short!').max(15, 'Too Long!').required('Required'),
        last_name: Yup.string().min(3, 'Too Short!').max(15, 'Too Long!').required('Required'),
        role: Yup.string().required('Required'),
        email: Yup.string().email('Invalid email').required('Required'),
        password: Yup.string()
            .required('No password provided.')
            .min(8, 'Password is too short - should be 8 chars minimum.')
            .matches(/[a-zA-Z0-9!$%^#&*()_+-={}@~<>;:]/, 'Password can only contain Latin letters.'),
        confirm_password: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match')
    });

    const roleData = [
        {
            label: 'Admin',
            value: 'admin'
        },
        {
            label: 'Customer',
            value: 'customer'
        },
        {
            label: 'Tester',
            value: 'tester'
        },
        {
            label: 'Developer',
            value: 'developer'
        }
    ];

    return (
        <div className="p-5 form_container mx-auto">
            <div className="heading mb-3 text-center">
                <h3>Signup</h3>
            </div>
            <Formik
                initialValues={{
                    first_name: '',
                    last_name: '',
                    role: '',
                    email: '',
                    password: '',
                    confirm_password: ''
                }}
                validationSchema={validate}
                onSubmit={async (values) => {
                    const userSignupData = {
                        email: values.email,
                        first_name: values.first_name,
                        last_name: values.last_name,
                        password: values.password,
                        role: values.role
                    };
                    console.log(userSignupData);
                    const response = await sendRequest(BASE_URL + '/user/register', { payload: userSignupData });
                    if (response.status === 200) {
                        successToast(response.data.desc);
                        navigate('/login');
                    } else {
                        console.log(response.data.desc);
                        errorToast(response.data.desc);
                    }
                }}
            >
                <Form>
                    <FormField label="First Name" name="first_name" type="text" />
                    <FormField label="Last Name" name="last_name" type="text" />
                    <FormSelect label="Role" name="role" data={roleData} />
                    <FormField label="Email Address" name="email" type="email" />
                    <div className="mb-3">
                        <label>Password</label>
                        <div className="position-relative">
                            <input className="form-control" type={showPassword ? 'text' : 'password'} name="password" />
                            <Button variant="link" className="position-absolute top-50 end-0 translate-middle-y px-2" onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </Button>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label>Confirm Password</label>
                        <div className="position-relative">
                            <input className="form-control" type={showConfirmPassword ? 'text' : 'password'} name="confirm_password" />
                            <Button
                                variant="link"
                                className="position-absolute top-50 end-0 translate-middle-y px-2"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                            </Button>
                        </div>
                    </div>
                    <div className="text-end mb-3">
                        <Link to={'/forgot'} className="text-dark">
                            Forgot Password?
                        </Link>
                    </div>
                    <div className="d-grid gap-2">
                        <Button type="submit" className="theme-btn" disabled={loading}>
                            SignUp
                        </Button>
                        <span className="text-center text-muted">or</span>
                        <Link to="/login" className="d-grid text-center text-dark">
                            <Button className="theme-outline-cancel-btn">Login</Button>
                        </Link>
                    </div>
                </Form>
            </Formik>
        </div>
    );
};

export default SignupForm;
